
import './js/jointjs/joint-min';
import './style/jointjs/joint.css';

window.joint = require('./js/jointjs/joint-min');

